import { useCallback } from 'react';
import { toast } from '@hooks/use-toast';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../../../../services/api';

export const useReorder = () => {
  const { t } = useTranslation();

  const reorder = useCallback(
    async ({ model, items }) => {
      try {
        const response = await axiosInstance.post('/api/reorder/', {
          model,
          items,
        });
        return response.data;
      } catch (err) {
        const description =
          err.response?.data?.message ||
          err.response?.data?.detail ||
          err.message ||
          t(
            'common|Erreur durant la réorganisation des éléments. Veuillez réessayer plus tard.'
          );

        toast({
          variant: 'destructive',
          title: t('common|Error'),
          description,
        });

        throw err;
      }
    },
    [t]
  );

  return { reorder };
};
